import { render, staticRenderFns } from "./CasosActivosConInformeDeLiquidación.vue?vue&type=template&id=a1c1c206&"
import script from "./CasosActivosConInformeDeLiquidación.vue?vue&type=script&lang=js&"
export * from "./CasosActivosConInformeDeLiquidación.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports